export const ruTranslation = {
  header: {
    homeProjectors: "Домашние проекторы",
    portableProjectors: "Портативные проекторы",
    support: "Поддержка",
    promotion: "Акция",
    dropdownHome: "Модели домашних проекторов и аксессуары",
    dropdownPortable: "Модели портативных проекторов и внешние аккумуляторы",
    dropdownSupport:
      "Часто задаваемые вопросы, руководства и контактная информация",
  },
  main: {
    fastSelfHelpSupport: "Быстрая самопомощь",
    card1: {
      title: "Предпродажные вопросы",
      description: "Как купить с большой скидкой?",
      link: "Узнать больше",
    },
    card2: {
      title: "Поддержка продукта",
      description: "Возникли проблемы с использованием проектора?",
      link: "Выберите вашу модель",
    },
    card3: {
      title: "Послепродажное обслуживание",
      description: "Гарантия, возврат, политика обмена",
      link: "Узнать больше",
    },
    getSupport: {
      title: "Получите поддержку от нас",
      replyTime: "Обычно мы отвечаем в течение 1 рабочего дня.",
      checkFaq:
        "При возникновении проблем с устройством, пожалуйста, сначала ознакомьтесь с документом {faqLink}",
    },
  },
  form: {
    name: "Имя",
    email: "Электронная почта",
    order_id: "Ваш номер заказа",
    orderNumberHelp: "Как найти мой номер заказа?",
    describeIssue: "Пожалуйста, опишите проблему",
    descriptionHelp:
      "Пожалуйста, предоставьте как можно больше фотографий и видео неисправности, чтобы мы могли быстро определить решение.",
    fileUpload: "Загрузка файлов",
    fileUploadInstructions: "{action} в эту область для загрузки.",
    fileUploadInstructionsAction: "Нажмите или перетащите файлы",
    fileUploadLimit: "Вы можете загрузить до 5 файлов.",
    filesSelected: "Выбрано {{count}}/5 файлов.",
    maxFilesError: "Вы можете загрузить не более 5 файлов.",
    surveyTitle:
      "Небольшой опрос - какие улучшения вы хотели бы видеть в вашем следующем проекторе?",
    surveyPlaceholder: "например: я хочу, чтобы он был ярче, громче и т.д.",
    submit: "Отправить",
    nextButton: "Далее",
    previousButton: "Назад",
    submitSuccess: "Заявка в поддержку отправлена! Мы скоро с вами свяжемся.",
    step2: {
      expectation: {
        label: "Соответствует ли он вашим ожиданиям?",
        optionYes: "Да, он хорошо работает",
        optionNo: "Нет, у него есть проблемы",
      },
      rating: {
        label: "Как бы вы его оценили?",
      },
      features: {
        label:
          "Небольшой опрос - какие особенности наших продуктов привлекают вас больше всего?",
        placeholder:
          "Например: внешний вид, доступная цена, уникальный дизайн и т. д.",
      },
    },
    step3: {
      title: "Пожалуйста, получите свой подарок за активацию! Это бесплатно!",
      gift1Title: "1 год дополнительной гарантии",
      gift2Title: "180 дней бесплатной замены",
      confirmation:
        "Мы отправим письмо с подтверждением на ваш почтовый ящик, пожалуйста, подтвердите получение в письме.",
      activateButton: "Активировать сейчас",
    },
    step4: {
      title: "Вы успешно активировали гарантию!",
      line1:
        "Надеюсь, вам понравится подарок за активацию, который мы для вас приготовили.",
      line2:
        "Вы получили письмо с подтверждением. Пожалуйста, проверьте свой почтовый ящик, чтобы подтвердить выбранные преимущества.",
      line3: "Если вы не можете его найти, проверьте папку со спамом.",
    },
    errors: {
      nameRequired: "Имя обязательно для заполнения.",
      emailRequired: "Электронная почта обязательна для заполнения.",
      emailInvalid: "Неверный формат электронной почты.",
      order_idRequired: "Номер заказа обязателен для заполнения.",
      order_idInvalid:
        "Неверный формат номера заказа (например, XXX-XXXXXXX-XXXXXXX).",
      commentRequired: "Пожалуйста, опишите проблему.",
      filesRequired: "Требуется хотя бы один файл.",
      surveyRequired: "Поле опроса обязательно для заполнения.",
      expectationRequired: "Пожалуйста, выберите вариант.",
      ratingRequired: "Пожалуйста, поставьте оценку.",
      featuresRequired: "Это поле опроса обязательно для заполнения.",
      giftRequired: "Пожалуйста, выберите подарок для активации.",
    },
  },
  footer: {
    newsletterTitle: "Подпишитесь на нашу рассылку",
    newsletterDescription:
      "Подпишитесь на нашу рассылку, чтобы получать персонализированные новости о продуктах, обновления и специальные приглашения",
    emailPlaceholder: "Адрес электронной почты",
    signUp: "Подписаться",
    products: "Продукты",
    support: "Поддержка",
    contactUs: "Связаться с нами",
    preSales: "Предпродажные вопросы",
    productSupport: "Поддержка продукта",
    afterSales: "Послепродажное обслуживание",
    contactInfo: "Контактная информация",
    workingHours: "(CST): Пн-Вс 9:00-19:00",
  },
};
